// extracted by mini-css-extract-plugin
module.exports = {"text":"VehicleIconLabel_text__yfRTZ","label":"VehicleIconLabel_label__2bw1-"};